// 库存管理

export default {
  /**
  *
* 库存明细
*/
  // 列表
  getInventoryDetailsList: '/inventory/listPage',
  /**
    *
  * 库存统计
  */
  // 列表
  getInventoryStatisticsList: '/inventory/inventoryBeStatListPage',

}